import React, { useEffect, useState } from "react";
import { object } from "prop-types";

import { optionsType } from "../../../prop-types";
import { Col, Row } from "reactstrap";
import "./buttonSelectMultipleClients.css";
import { LegalEntityIcon, NaturalPersonIcon } from "../../../assets";
import {
  CLIENT_TYPE_LABELS,
  CLIENT_TYPE_VALUES,
} from "../../../features/monitoring-queue-entry/constants/monitoringQueueEntryConstants";
import { Field } from "formik";
import SelectForClientType from "../SelectForClientType/SelectForClientType";

const getValue = (options, field) => {
  if (!options) {
    return "";
  }

  return options.filter((option) =>
    Array.isArray(field.value)
      ? field.value.indexOf(option.value) >= 0
      : field.value === option.value
  );
};

const ButtonSelectMultipleClients = ({
  options,
  field,
  form: { setFieldValue },
}) => {
  const [groupedOptions, setGroupedOptions] = useState({
    [CLIENT_TYPE_VALUES.COMPANY]: [],
    [CLIENT_TYPE_VALUES.PERSON]: [],
  });

  const value = getValue(options, field);

  useEffect(() => {
    if (options) {
      const tempGroup = {
        [CLIENT_TYPE_VALUES.COMPANY]: [],
        [CLIENT_TYPE_VALUES.PERSON]: [],
      };

      options.map((option) => {
        if (tempGroup[option.targetTypeCategory]) {
          tempGroup[option.targetTypeCategory].push(option);
        }

        return null;
      });

      setGroupedOptions(tempGroup);
    }
  }, [options]);

  const handleChange = (option) => {
    if (!option) {
      return setFieldValue(field.name, null);
    }
    const newValue = Array.isArray(option.value)
      ? option.map((item) => item.value)
      : option.value;

    return setFieldValue(field.name, newValue);
  };

  const getClassName = (option) => {
    const base =
      "d-flex justify-content-between selectable-button-multiple-clients align-items-center ";
    if (!value.length) {
      return base;
    }

    if (option.value === value[0].value) {
      return base + "active-selectable-button-multiple-clients";
    }
    return base;
  };

  function RenderIcon({ optionValue = "" }) {
    if (optionValue === CLIENT_TYPE_VALUES.PERSON) {
      return <NaturalPersonIcon width={16} height={16} />;
    }

    if (optionValue === CLIENT_TYPE_VALUES.COMPANY) {
      return <LegalEntityIcon width={16} height={16} />;
    }

    return null;
  }

  const RenderOption = ({ option, type }) => {
    if (option.length === 1) {
      const opt = option[0];
      return (
        <div
          className={getClassName(opt)}
          color="primary"
          outline
          onClick={() => handleChange(opt)}
        >
          <span>
            <RenderIcon optionValue={opt.targetTypeCategory} />
          </span>
          <span className="pr-3">{CLIENT_TYPE_LABELS[opt.label]}</span>
          <div />
        </div>
      );
    } else if (option.length) {
      return (
        <Field
          targetTypeCategory={option[0].targetTypeCategory}
          name={field.name}
          placeholder={CLIENT_TYPE_LABELS[option[0].targetTypeCategory]}
          options={option}
          component={SelectForClientType}
        />
      );
    } else {
      return (
        <div
          className="d-flex justify-content-between align-items-center no-option"
          color="primary"
          outline
          onClick={() => {}}
        >
          <RenderIcon optionValue={type} />
          <span>{type}</span>
          <div />
        </div>
      );
    }
  };

  return (
    <Row>
      <Col lg={6} className="pr-2">
        <RenderOption
          option={groupedOptions[CLIENT_TYPE_VALUES.PERSON]}
          type={CLIENT_TYPE_VALUES.PERSON}
        />
      </Col>
      <Col lg={6} className="pl-2">
        <RenderOption
          option={groupedOptions[CLIENT_TYPE_VALUES.COMPANY]}
          type={CLIENT_TYPE_VALUES.COMPANY}
        />
      </Col>
    </Row>
  );
};

ButtonSelectMultipleClients.propTypes = {
  options: optionsType.isRequired,
  form: object.isRequired,
  field: object.isRequired,
};

export default ButtonSelectMultipleClients;



// WEBPACK FOOTER //
// ./src/components/formik/multiple-clients/ButtonSelectMultipleClients.jsx